import React from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

export const ButtonMobile = ({
	width,
	height,
	diameter,
	season,
	tipVozila,
	manufacturer,
	isSubmitting,
	isFieldsLoading,
	submit,
	onCloseModal
}) => {
	const { t } = useTranslation('common')

	const isDisabled = isSubmitting || isFieldsLoading

	return (
		<div className='filter-buttons filter-buttons-mobile'>
			<button
				className={`filter-buttons-search${isDisabled ? ' disabled' : ''}`}
				onClick={!isDisabled ? () => {
					const values = {}

					if (Number(width) && Number(width) !== -1) values.width = width
					if (Number(height) && Number(height) !== -1) values.height = height
					if (Number(diameter) && Number(diameter) !== -1) values.diameter = diameter
					if (season && Number(season) !== -1) values.season = season
					if (tipVozila && Number(tipVozila) !== -1) values.tire_vehicle_type = tipVozila
					if (manufacturer && Number(manufacturer) !== -1) values.manufacturer = manufacturer

					submit(values)
					onCloseModal && onCloseModal()
				} : () => { }}
			>
				<i className='ogl-header-ico ico-pretraga-text-search-lupa ico' />
				<span style={{ textTransform: 'uppercase' }}>{t('Pretraži djelove')}</span>
			</button>
		</div>
	)
}
